import { render, staticRenderFns } from "./addImageType.vue?vue&type=template&id=125a02eb&"
import script from "./addImageType.vue?vue&type=script&lang=js&"
export * from "./addImageType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports